import React from 'react';
import { PageHero, BottomCTA } from '../components/PageHelpers';
import { Sec, SH } from '../components/Section';
import { MockupGraphic } from '../components/MockupGraphic';
import { ScoringWidget, PlatformFeatures } from '../widgets';

export const PlatformPage = () => {
  return (
    <div data-testid="platform-page">
      {/* Exact original content */}
      <PageHero
        eyebrow="FULL PLATFORM"
        title="A Complete Intelligence &"
        accent="Enablement Platform"
        subtitle="Score. Insights. Artefacts. Strategy."
        body="Everything you need to transform presentations into closing machines."
        cta="Get Free Score"
        ctaLink="/score"
        cta2="View Pricing"
        cta2Link="/pricing"
      />

      <ScoringWidget />
      <PlatformFeatures />

      <BottomCTA
        title="Ready to Transform Your Deck"
        accent="to DecX?"
        subtitle="Start free. Get your score. Close your deal."
        ctaText="Get Free DecX Score"
        ctaLink="/score"
      />
    </div>
  );
};
